
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"opacity":".4","cx":"10","cy":"10","r":"10","fill":"#E89B12"}}),_c('circle',{attrs:{"cx":"10","cy":"10","r":"8","fill":"#E89B12"}}),_c('path',{attrs:{"d":"M7.704 14.06a.522.522 0 01-.384-.156.522.522 0 01-.156-.384V6.176c0-.152.052-.28.156-.384a.503.503 0 01.384-.168h2.736c.76 0 1.38.128 1.86.384.48.256.824.584 1.032.984.208.4.312.832.312 1.296 0 .464-.104.896-.312 1.296-.208.4-.552.728-1.032.984s-1.1.384-1.86.384H8.256v2.568c0 .152-.056.28-.168.384a.522.522 0 01-.384.156zm2.628-4.14c.816 0 1.388-.156 1.716-.468.336-.312.504-.7.504-1.164 0-.464-.168-.852-.504-1.164-.328-.312-.9-.468-1.716-.468H8.256V9.92h2.076z","fill":"#fff","stroke":"#fff","stroke-width":".6"}})])
          )
        }
      }
    